import React, { createRef } from "react";
import DropdownMenu from "./DropdownMenu";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { startLogout } from "../actions/auth";

export class Header extends React.Component {
    state = {
        showDropdownMenu: false
    };

    handleOnClick = () => {
        this.setState(prevState => ({
            showDropdownMenu: !prevState.showDropdownMenu
        }))
    };

     render() {
        return (
        <header className="header">
                <div className="header__content">   
                    <div className="header_left_column">    
                        <Link className="header__title" to="/dashboard">
                            <img className="main-logo" src="/images/FullLogo_Transparent_NoBuffer.png" />
                        </Link>
                    </div> 
                    <div className="header_right_column">
                        <div className="header_welcome">
                            <p className="welcome_text">Welcome back, { this.props.currentUser.displayName }!</p>
                            <p className="logout_prompt">Not you? <span onClick={ startLogout() } className="pseudo_link">Logout</span></p>
                        </div>
                        <div className="profile_pic">
                            <img 
                                className="header__avatar" 
                                src={ this.props.currentUser.photoURL || "/images/default_avatar.png" } 
                                onClick={ this.handleOnClick }>
                            </img>
                        </div>
                    </div>            
                </div>
                
                 { this.state.showDropdownMenu ? <div className="content-container right"><DropdownMenu /></div> : null } 
        </header>
        )
    };
};
  
const mapStateToProps = (state) => ({
  currentUser: state.auth.currentUser,
  authfxUser: state.authfx.userinfo
});

const mapDispatchToProps = (dispatch) => ({
    startLogout: () => dispatch(startLogout())
  
});

export default connect(mapStateToProps, mapDispatchToProps)(Header);


// WEBPACK FOOTER //
// ./src/components/Header.js